import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking | paid | timeout

  useEffect(() => {
    let attempts = 0;
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts += 1;
      try {
        const { data } = await api.get("/subscription/status");
        if (data.status === "active") {
          await refresh();
          setState("paid");
          return;
        }
      } catch (e) {
        /* keep trying */
      }
      if (attempts >= 15) {
        setState("timeout");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [refresh]);

  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="payment-success">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto text-[#2E9D96] animate-spin" size={40} />
            <h1 className="font-display text-3xl text-slate-800 mt-6">Confirming your subscription…</h1>
            <p className="text-slate-500 mt-2">One sec while we get everything sorted.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-[#2E9D96]" size={48} />
            <h1 className="font-display text-4xl text-slate-800 mt-6">You're all set.</h1>
            <p className="text-slate-600 mt-2">Zaf's in your corner — anytime you need. Welcome back.</p>
            <Link
              to="/chat"
              data-testid="success-to-chat"
              className="inline-flex mt-8 items-center gap-2 bg-[#2E9D96] hover:bg-[#1F7B75] text-white font-semibold px-8 py-3.5 rounded-full transition-colors"
            >
              Talk to Zaf
            </Link>
          </>
        )}
        {state === "timeout" && (
          <>
            <h1 className="font-display text-3xl text-slate-800">Almost there…</h1>
            <p className="text-slate-600 mt-2">
              Your payment may still be processing. Give it a moment, then head back to chat.
            </p>
            <Link
              to="/chat"
              className="inline-flex mt-8 items-center gap-2 bg-[#2E9D96] hover:bg-[#1F7B75] text-white font-semibold px-8 py-3.5 rounded-full transition-colors"
            >
              Back to chat
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
